import { CustomCssVarsFn } from '@wix/yoshi-flow-editor';

import {
  designStylesParams,
  DesignStylesParams,
} from './Settings/Tabs/Design/stylesParams';

export type StylesParams = DesignStylesParams;

export const stylesParams = {
  ...designStylesParams,
};

export default stylesParams;

export const customCssVars: CustomCssVarsFn = ({ styleParams }) => {
  return {};
};
